import { render, staticRenderFns } from "./InspectionDocumentEditor.vue?vue&type=template&id=4abe383c&"
import script from "./InspectionDocumentEditor.vue?vue&type=script&lang=js&"
export * from "./InspectionDocumentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports